<template>
  <layout-apply-cancel
    @cancel="cancel"
    @apply="applyClick"
    :apply-disabled="objectTrackingInFlight"
  />
</template>

<script>
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import objectTrackingMixin from 'AssetEditor/functionality/CustomOverlays/mixins/objectTracking';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  mixins: [objectTrackingMixin],

  computed: {
    ...mapGetters('assetEditor', ['currentPage', 'themeInfo', 'presets']),

    name() {
      return this.currentPage.displayText;
    },

    id() {
      return this.currentPage.id;
    },
  },

  mounted() {
    this.track({
      e: 'selectedCustomOverlay',
      params: {
        overlay: this.name,
        overlayType: this.getSelectedCustomOverlayType(),
      },
    });
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage', 'track']),

    cancel() {
      this.changeCurrentPage('preview');
    },

    applyClick() {
      // tracking must be created before the AGD is committed, so the id is
      // already on the overlay when CustomOverlaysFields#apply promotes tmpAGD
      const appliedOverlayId = this.id;

      this.ensureObjectTracking().then((canApply) => {
        // Cancel stays enabled while the request is in flight - applying now
        // would commit whatever page the user moved on to
        if (!canApply || this._isDestroyed || this.id !== appliedOverlayId) {
          return;
        }
        bus.$emit('apply-click');
      });
    },

    getSelectedCustomOverlayType() {
      const preset = this.presets.find((preset) => preset.id === this.id);

      if (preset && !_.isEmpty(preset.layers)) {
        return preset.layers.join(' and ');
      }

      return '';
    },
  },
};
</script>
